import Decimal from 'decimal.js';

export const codToCents = (cod: number) =>
  cod === 0 ? 0 : Number(new Decimal(cod).sub(1).mul(100));
